import { CalculationMode } from 'common/interfaces';
import { RentData } from 'stores/workflowStores/finances/rent/model';

export const rentIsZero = (rentData?: RentData): boolean => {
  return (
    rentData !== undefined &&
    rentData.portfolioRentCalculationMode === CalculationMode.CALCULATED &&
    rentData.calculatedPortfolioRent &&
    rentData.calculatedPortfolioRent.value === 0
  );
};
